module.exports = __webpack_public_path__ + "public/Icons/manage_currency.svg?2099e6f6";